import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
  import useIcons from '@/composables/useIcons'
  import Choice from './Choice.vue'
  import NumberInput from '@/components/common/NumberInput.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import useFlags from '@/composables/useFlags'
  import type { PropType } from 'vue'
  import type { SvgRendererProps } from '@/services/interfaces/Common'
  import type { Question } from '@/services/interfaces/QuizQuestion'
  import type { CourseExamQuestion } from '@/services/interfaces/Course'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Question',
  props: {
    question: {
      type: Object as PropType<Question | CourseExamQuestion>,
      required: true,
    },
    questionNumber: {
      type: Number,
      default: null,
    },
    underlineTitle: {
      type: Boolean,
      default: true,
    },
    showQuestionNumber: {
      type: Boolean,
      default: true,
    },
    inResultsMode: {
      type: Boolean,
      default: false,
    },
    totalNumberOfQuestions: {
      type: Number,
      default: null,
    },
    questionHelperText: {
      type: String,
      default: '',
    },
    hasNewQuestions: {
      type: Boolean,
      default: false,
    },
    onChoiceClick: {
      type: Function as PropType<(answerId: string) => void>,
      required: true,
    },
    isChoiceSelected: {
      type: Function as PropType<(answerId: string) => boolean>,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const { checkedCircle, uncheckedCircle, checkedCheckboxSquareWhite, checkboxSquareWhite, wrongAnswerIcon } =
    useIcons()
  const { isFlagEnabled } = useFlags()
  const { correctNumberAnswer } = useCommonMixin()
  const numberInputModel = ref('')

  const isCorrectNumberAnswer = computed(() => {
    if (typeof (props.question as CourseExamQuestion).userNumberAnswer === 'object') {
      return (props.question as CourseExamQuestion).userNumberAnswer?.isCorrect
    }
    return correctNumberAnswer(props.question.answers[0].answer, numberInputModel.value)
  })

  const isCorrectAnswer = computed(() => {
    return (answerId: string) => !!props.question.answers.find((a) => a.isCorrect && a.answerId === answerId)
  })

  const isWrongAnswer = computed(() => {
    return (answerId: string) => {
      return !isCorrectAnswer.value(answerId) && props.isChoiceSelected(answerId)
    }
  })

  const isTestingQuizFlagEnabled = computed(() => isFlagEnabled('testing-quiz'))

  const choiceIcon = computed(() => {
    return (answerId: string): SvgRendererProps => {
      const svgProps: any = { strokeColor: 'var(--primary-text-color)' }

      if (props.question.questionType === 'single') {
        svgProps.icon = uncheckedCircle.value
        if (props.isChoiceSelected(answerId)) {
          svgProps.icon = checkedCircle.value
          setWrongOrCorrectIconProps(svgProps, answerId)
          return svgProps
        }
        if (props.inResultsMode && isCorrectAnswer.value(answerId)) svgProps.icon = checkedCircle.value
        return svgProps
      }

      svgProps.icon = checkboxSquareWhite.value
      if (props.isChoiceSelected(answerId)) {
        svgProps.icon = checkedCheckboxSquareWhite.value
        setWrongOrCorrectIconProps(svgProps, answerId)
        return svgProps
      }
      if (props.inResultsMode && isCorrectAnswer.value(answerId)) svgProps.icon = checkedCheckboxSquareWhite.value
      return svgProps
    }
  })

  const setWrongOrCorrectIconProps = (svgProps: SvgRendererProps, answerId: string) => {
    if (props.inResultsMode) {
      if (isCorrectAnswer.value(answerId)) {
        svgProps.strokeColor = '#28bd2e'
      } else {
        svgProps.icon = wrongAnswerIcon.value
        svgProps.strokeColor = '#ff0044'
      }
    }
  }

  const setFormattedNumberInput = () => {
    if (props.question.questionType === 'number' && props.question.userNumberAnswer) {
      if (typeof props.question.userNumberAnswer === 'object') {
        numberInputModel.value = props.question.userNumberAnswer?.answer
      } else {
        numberInputModel.value = props.question.userNumberAnswer
      }
    }
  }

  watch(numberInputModel, (value) => props.onChoiceClick(value ? String(value) : ''))

  setFormattedNumberInput()

return { __sfc: true,props, checkedCircle, uncheckedCircle, checkedCheckboxSquareWhite, checkboxSquareWhite, wrongAnswerIcon, isFlagEnabled, correctNumberAnswer, numberInputModel, isCorrectNumberAnswer, isCorrectAnswer, isWrongAnswer, isTestingQuizFlagEnabled, choiceIcon, setWrongOrCorrectIconProps, setFormattedNumberInput, computed, ref, watch, useIcons, Choice, NumberInput, HTMLRenderer, useFlags, useCommonMixin }
}

})